import { z } from 'zod'

export type Lane = 'ops' | 'product'
export type Urgency = 'critical' | 'high' | 'moderate' | 'strong'

export type Answers = {
  pains: string[]
  team?: string
  hours?: string
  industry?: string
  systems: string[]
  goal?: string
  stage?: string
  challenges: string[]
  techTeam?: string
  timeline?: string
  priority?: string
  freeText?: string
  companyUrl?: string
}

export type DiagnosticResult = {
  contractVersion?: string
  resultId?: string
  lane: Lane
  score: number
  urgency: Urgency
  headline: string
  status: string
  context: string
  callout?: string | null
  stats: Array<{ value: string; label: string; note?: string }>
  assessmentSummary?: Array<{ label: string; value: string }>
  personalAnalysis?: string
  bottlenecks: Array<{ sev: 'high' | 'medium' | 'low'; title: string; body: string }>
  recommendations: Array<{ title: string; fit: string; body: string; url: string; why: string }>
  futureState: Array<{ pain: string; today: string; after: string }>
  capacityTranslation: string
  roadmap: string[]
  meta?: { generated: boolean; model?: string; promptVersion?: string }
}

export const DiagnosticResultSchema = z.object({
  contractVersion: z.literal('2.0'), resultId: z.string().optional(), lane: z.enum(['ops','product']), score: z.number().min(0).max(100), urgency: z.enum(['critical','high','moderate','strong']),
  headline: z.string(), status: z.string(), context: z.string(), callout: z.string().nullable().optional(),
  stats: z.array(z.object({value:z.string(),label:z.string(),note:z.string().optional()})).min(1), assessmentSummary:z.array(z.object({label:z.string(),value:z.string()})).optional(), personalAnalysis:z.string().optional(),
  bottlenecks:z.array(z.object({sev:z.enum(['high','medium','low']),title:z.string(),body:z.string()})).min(1),
  recommendations:z.array(z.object({title:z.string(),fit:z.string(),body:z.string(),url:z.string(),why:z.string()})).min(1),
  futureState:z.array(z.object({pain:z.string(),today:z.string(),after:z.string()})).min(1), capacityTranslation:z.string(), roadmap:z.array(z.string()).min(1),
  meta:z.object({generated:z.boolean(),model:z.string().optional(),promptVersion:z.string().optional()}).optional(),
})

export type Option = { value: string; label: string; description: string }
